const AWS = require('aws-sdk')

const bucketName = 'bluetractor-mercury'
const bucketRegion = 'us-east-2'
// const IdentityPoolId = 'us-east-2:b29412be-9461-46f0-b743-90a020cba4c1'
const AWS_ACCESS_KEY = 'AKIAIBKQRLKTRVRR7WDQ'
const AWS_SECRET_ACCESS_KEY = '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'
const s3baseUrl = 'https://s3.us-east-2.amazonaws.com/bluetractor-mercury'

AWS.config.update({
  region: bucketRegion,
  accessKeyId: AWS_ACCESS_KEY,
  secretAccessKey: AWS_SECRET_ACCESS_KEY
})

const s3 = new AWS.S3({
  params: { Bucket: bucketName }
})

const removeFromS3 = function (imageKey) {
  return new Promise((resolve, reject) => {
    if (!imageKey) {
      reject(new Error('Missing params: imageKey'))
    }
    s3.deleteObject({
      Key: imageKey
    }, (err, data) => {
      if (err) {
        reject(new Error(err.message))
      }
      resolve(data)
    })
  })
}

const uploadToS3 = function (imageKey, file, progressFn = data => {}) {
  return new Promise((resolve, reject) => {
    if (!imageKey || !file) {
      reject(new Error('Missing params: need imageKey and file'))
    }
    s3.upload({
      Key: imageKey,
      Body: file
    }, (err, data) => {
      if (err) {
        reject(new Error(err.message))
      }
      resolve(data)
    }).on('httpUploadProgress', progressFn)
  })
}

export default {
  s3,
  s3baseUrl,
  removeFromS3,
  uploadToS3
}
